<template>
    
    <div>
        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Horizontal Divider</h2>

        <div class="preview-box" :style="{width : previewBoxWidth}">

            <!-- desktop styles simpleDivider -->
            <vstyle v-if="settingsFromWeebly.dividerTypeObj.simpleDivider">
                #{{uniqueId+'-wrapper'}} {
                    text-align: {{settingsFromWeebly.dividerAlign}};
                    margin: {{settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottom}}px;
                }
                #{{uniqueId}} {
                    font-size: 0;
                    display: inline-block;
                    width: 100%;
                    max-width: {{settingsFromWeebly.dividerWidth}}px;
                    background: {{settingsFromWeebly.dividerColor}};
                    height: {{settingsFromWeebly.dividerHeight}}px;
                }
                @media(max-width: 768px) {
                    #{{uniqueId+'-wrapper'}} {
                        text-align: {{settingsFromWeebly.dividerAlignTablet || settingsFromWeebly.dividerAlign}};
                        margin: {{settingsFromWeebly.dividerMarginTopTablet || settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottomTablet || settingsFromWeebly.dividerMarginBottom}}px;
                        max-width: {{settingsFromWeebly.dividerWidthTablet || settingsFromWeebly.dividerWidth}}px;
                    }
                }

                @media(max-width: 576px) {
                    #{{uniqueId+'-wrapper'}} {
                        text-align: {{settingsFromWeebly.dividerAlignPhone || settingsFromWeebly.dividerAlignTablet || settingsFromWeebly.dividerAlign}};
                        margin: {{settingsFromWeebly.dividerMarginTopPhone || settingsFromWeebly.dividerMarginTopTablet || settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottomPhone || settingsFromWeebly.dividerMarginBottomTablet || settingsFromWeebly.dividerMarginBottom}}px;
                        max-width: {{settingsFromWeebly.dividerWidthPhone || settingsFromWeebly.dividerWidthTablet || settingsFromWeebly.dividerWidth}}px;
                    }
                }
            </vstyle>

            <!-- tablet styles simpleDivider -->
            <vstyle v-if="deviceStylesSetttings.tabletStyles && settingsFromWeebly.dividerTypeObj.simpleDivider">
                #{{uniqueId+'-wrapper'}} {
                    text-align: {{settingsFromWeebly.dividerAlignTablet || settingsFromWeebly.dividerAlign}};
                    margin: {{settingsFromWeebly.dividerMarginTopTablet || settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottomTablet || settingsFromWeebly.dividerMarginBottom}}px;
                    max-width: {{settingsFromWeebly.dividerWidthTablet || settingsFromWeebly.dividerWidth}}px;
                }
            </vstyle>

            <!-- mobile styles simpleDivider -->
            <vstyle v-if="deviceStylesSetttings.mobileStyles && settingsFromWeebly.dividerTypeObj.simpleDivider">
                #{{uniqueId+'-wrapper'}} {
                    text-align: {{settingsFromWeebly.dividerAlignPhone || settingsFromWeebly.dividerAlignTablet || settingsFromWeebly.dividerAlign}};
                    margin: {{settingsFromWeebly.dividerMarginTopPhone || settingsFromWeebly.dividerMarginTopTablet || settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottomPhone || settingsFromWeebly.dividerMarginBottomTablet || settingsFromWeebly.dividerMarginBottom}}px;
                    max-width: {{settingsFromWeebly.dividerWidthPhone || settingsFromWeebly.dividerWidthTablet || settingsFromWeebly.dividerWidth}}px;
                }
            </vstyle>

            <!-- simpleDivider html markup -->
            <div :id="uniqueId+'-wrapper'" v-if="settingsFromWeebly.dividerTypeObj.simpleDivider">
                <div :id="uniqueId">

                </div>
            </div>

            <!-- desktop styles iconCenterDivider / iconLeftDivider / iconRightDivider -->
            <vstyle v-if="settingsFromWeebly.dividerTypeObj.iconCenterDivider || settingsFromWeebly.dividerTypeObj.iconLeftDivider || settingsFromWeebly.dividerTypeObj.iconRightDivider">
                 #{{uniqueId+'-wrapper'}} {
                    margin: {{settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottom}}px;
                    width: 100%;
                    max-width: {{settingsFromWeebly.dividerWidth}}px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    {{settingsFromWeebly.dividerAlign === 'left' ? 'margin-left: 0;': ''}}
                    {{settingsFromWeebly.dividerAlign === 'right' ? 'margin-right: 0;': ''}}
                }
                #{{uniqueId+'-wrapper'}} .divider--line {
                    background: {{settingsFromWeebly.dividerColor}};
                    height: {{settingsFromWeebly.dividerHeight}}px;
                    -webkit-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                }
                #{{uniqueId+'-wrapper'}} i {
                    margin: 0 15px;
                    color: {{settingsFromWeebly.iconColor}};
                    font-size: {{settingsFromWeebly.iconSize}}px;
                }
                 @media(max-width: 768px) {
                    #{{uniqueId+'-wrapper'}} {
                        max-width: {{settingsFromWeebly.dividerWidthTablet || settingsFromWeebly.dividerWidth}}px;

                        margin: {{settingsFromWeebly.dividerMarginTopTablet || settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottomTablet || settingsFromWeebly.dividerMarginBottom}}px;

                        {{ ( settingsFromWeebly.dividerAlignTablet === null && settingsFromWeebly.dividerAlign === 'left' ) ? 'margin-left: 0;': '' }}
                        {{ ( settingsFromWeebly.dividerAlignTablet === null && settingsFromWeebly.dividerAlign === 'right' ) ? 'margin-right: 0;': '' }}

                        {{ (settingsFromWeebly.dividerAlignTablet && settingsFromWeebly.dividerAlignTablet === 'left') ? 'margin-left: 0;': ''}}
                        {{ (settingsFromWeebly.dividerAlignTablet && settingsFromWeebly.dividerAlignTablet === 'right') ? 'margin-right: 0;': ''}}
                    }
                    #{{uniqueId+'-wrapper'}} i {
                        font-size: {{settingsFromWeebly.iconSizeTablet || settingsFromWeebly.iconSize}}px;
                    }
                }
                @media(max-width: 576px) {
                    #{{uniqueId+'-wrapper'}} {
                        max-width: {{settingsFromWeebly.dividerWidthPhone || settingsFromWeebly.dividerWidthTablet || settingsFromWeebly.dividerWidth}}px;

                        margin: {{settingsFromWeebly.dividerMarginTopPhone || settingsFromWeebly.dividerMarginTopTablet || settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottomPhone || settingsFromWeebly.dividerMarginBottomTablet || settingsFromWeebly.dividerMarginBottom}}px;

                        {{ ( settingsFromWeebly.dividerAlignPhone === null && (settingsFromWeebly.dividerAlignTablet === 'left' || (settingsFromWeebly.dividerAlignTablet !== null && settingsFromWeebly.dividerAlign === 'left') ) ) ? 'margin-left: 0;': '' }}

                        {{ ( settingsFromWeebly.dividerAlignPhone === null && (settingsFromWeebly.dividerAlignTablet === 'right' || (settingsFromWeebly.dividerAlignTablet !== null && settingsFromWeebly.dividerAlign === 'right') ) ) ? 'margin-right: 0;': '' }}

                        {{ (settingsFromWeebly.dividerAlignPhone && settingsFromWeebly.dividerAlignPhone === 'left') ? 'margin-left: 0;': ''}}
                        {{ (settingsFromWeebly.dividerAlignPhone && settingsFromWeebly.dividerAlignPhone === 'right') ? 'margin-right: 0;': ''}}
                    }
                    #{{uniqueId+'-wrapper'}} i {
                        font-size: {{settingsFromWeebly.iconSizePhone || settingsFromWeebly.iconSizeTablet || settingsFromWeebly.iconSize}}px;
                    }
                }               
            </vstyle>

            <!-- tablet styles iconCenterDivider / iconLeftDivider / iconRightDivider -->
            <vstyle v-if="(settingsFromWeebly.dividerTypeObj.iconCenterDivider || settingsFromWeebly.dividerTypeObj.iconLeftDivider || settingsFromWeebly.dividerTypeObj.iconRightDivider) && deviceStylesSetttings.tabletStyles">
                #{{uniqueId+'-wrapper'}} {
                    max-width: {{settingsFromWeebly.dividerWidthTablet || settingsFromWeebly.dividerWidth}}px;
                    margin: {{settingsFromWeebly.dividerMarginTopTablet || settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottomTablet || settingsFromWeebly.dividerMarginBottom}}px;

                    {{ ( settingsFromWeebly.dividerAlignTablet === null && settingsFromWeebly.dividerAlign === 'left' ) ? 'margin-left: 0;': '' }}
                    {{ ( settingsFromWeebly.dividerAlignTablet === null && settingsFromWeebly.dividerAlign === 'right' ) ? 'margin-right: 0;': '' }}

                    {{ (settingsFromWeebly.dividerAlignTablet && settingsFromWeebly.dividerAlignTablet === 'left') ? 'margin-left: 0;': ''}}
                    {{ (settingsFromWeebly.dividerAlignTablet && settingsFromWeebly.dividerAlignTablet === 'right') ? 'margin-right: 0;': ''}}

                }
                #{{uniqueId+'-wrapper'}} i {
                    font-size: {{settingsFromWeebly.iconSizeTablet || settingsFromWeebly.iconSize}}px;
                }
            </vstyle>

            <!-- mobile styles iconCenterDivider / iconLeftDivider / iconRightDivider -->
            <vstyle v-if="(settingsFromWeebly.dividerTypeObj.iconCenterDivider || settingsFromWeebly.dividerTypeObj.iconLeftDivider || settingsFromWeebly.dividerTypeObj.iconRightDivider) && deviceStylesSetttings.mobileStyles">
                #{{uniqueId+'-wrapper'}} {
                    max-width: {{settingsFromWeebly.dividerWidthPhone || settingsFromWeebly.dividerWidthTablet || settingsFromWeebly.dividerWidth}}px;
                    margin: {{settingsFromWeebly.dividerMarginTopPhone || settingsFromWeebly.dividerMarginTopTablet || settingsFromWeebly.dividerMarginTop}}px auto {{settingsFromWeebly.dividerMarginBottomPhone || settingsFromWeebly.dividerMarginBottomTablet || settingsFromWeebly.dividerMarginBottom}}px;

                    {{ ( settingsFromWeebly.dividerAlignPhone === null && (settingsFromWeebly.dividerAlignTablet === 'left' || (settingsFromWeebly.dividerAlignTablet !== null && settingsFromWeebly.dividerAlign === 'left') ) ) ? 'margin-left: 0;': '' }}

                    {{ ( settingsFromWeebly.dividerAlignPhone === null && (settingsFromWeebly.dividerAlignTablet === 'right' || (settingsFromWeebly.dividerAlignTablet !== null && settingsFromWeebly.dividerAlign === 'right') ) ) ? 'margin-right: 0;': '' }}

                    {{ (settingsFromWeebly.dividerAlignPhone && settingsFromWeebly.dividerAlignPhone === 'left') ? 'margin-left: 0;': ''}}
                    {{ (settingsFromWeebly.dividerAlignPhone && settingsFromWeebly.dividerAlignPhone === 'right') ? 'margin-right: 0;': ''}}
                }
                #{{uniqueId+'-wrapper'}} i {
                    font-size: {{settingsFromWeebly.iconSizePhone || settingsFromWeebly.iconSizeTablet || settingsFromWeebly.iconSize}}px;
                }
            </vstyle>

            <!-- iconCenterDivider html markup -->
            <div :id="uniqueId+'-wrapper'" v-if="settingsFromWeebly.dividerTypeObj.iconCenterDivider">
                <div class="divider--line"></div>
                <i :class="settingsFromWeebly.iconClass"></i>
                <div class="divider--line"></div>
            </div>

            <!-- iconLeftDivider html markup -->
            <div :id="uniqueId+'-wrapper'" v-if="settingsFromWeebly.dividerTypeObj.iconLeftDivider">
                <i :class="settingsFromWeebly.iconClass" style="margin-left: 0"></i>
                <div class="divider--line"></div>
            </div>

            <!-- iconRightDivider html markup -->
            <div :id="uniqueId+'-wrapper'" v-if="settingsFromWeebly.dividerTypeObj.iconRightDivider">
                <div class="divider--line"></div>
                <i :class="settingsFromWeebly.iconClass" style="margin-right: 0"></i>
            </div>

        </div>

    </div>

</template>

<script>
export default {

    name: 'HorizontalDivider',

    data() {
        return {
            uniqueId: 'horizontal-divider-'+Math.random().toString(36).substr(2, 16)
        }
    },
    
    components: {

        'vstyle': {
            render: function (createElement) {

                return createElement('style', this.$slots.default)
                
            }
        }

    },

    computed:{

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings.settings
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        }

    },

    mounted() {

        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')

    }
}
</script>

<style lang="less">

</style>





// WEBPACK FOOTER //
// src/components/elements/HorizontalDivider.vue